export const lsStylesFilterValStr = "styles_table_filter_obj";
export const lsFabricTrimsFilterValStr = "fab_trims_table_filter_obj";
export const lsBuyingFilterValStr = "buying_table_filter_obj";
